export const bingoGamesController = {
  initial: 'controllerDisabled',
  states: {
    controllerDisabled: {
      on: {
        LAYOUT_CHANGE_END: {
          cond: 'isControllerEnabled_bingoGames',
          target: 'fetchingBingoGames',
        },
      },
    },
    controllerIdle: {
      on: {
        LAYOUT_CHANGE_END: {
          cond: 'isControllerDisabled_bingoGames',
          target: 'controllerDisabled',
        },
        FETCH_BINGO_GAMES: 'fetchingBingoGames',
        RENDER_BINGO_GAMES: 'renderingBingoGames',
      },
    },
    fetchingBingoGames: {
      invoke: {
        src: 'fetchBingoGames',
        onDone: [
          {
            actions: ['saveFetchedBingoGames', 'watchBingoGamesTimer'],
            target: 'renderingBingoGames',
          },
        ],
      },
    },
    renderingBingoGames: {
      invoke: {
        src: 'prepareBingoGamesContent',
        onDone: {
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
          ],
          target: 'controllerIdle',
        },
      },
    },
  },
};
